<template>
    <div id="footer" :class="['align-c flex-center single', Classes().position]" v-if="show">
        <p>{{ CONFIG.project.name }} | Version {{ CONFIG.project.version }}</p>
    </div>
</template>

<script>
import { CONFIG } from "@/assets/JS/Config.js";

export default {
    name: "Footer",
    props: {
        show: Boolean,
        contentLoaded: Boolean
    },
    data: () => ({ CONFIG }),
    methods: {
        Classes: function() {
            return {
                position: this.contentLoaded ? "footer-inherit" : "footer-fixed"
            };
        }
    }
}
</script>